import React from 'react'
import ConsolidatedReportPrinting from '../../../components/ConsolidatedReportPrinting'

const EventConsolidatedReportPrinting: React.FC<any> = ({ eventId, eventTitle, childToParent }) => (
  <ConsolidatedReportPrinting
    title={eventTitle}
    eventIds={[eventId]}
    childToParent={childToParent}
  />
)

export default EventConsolidatedReportPrinting
